import { Badge, Group } from "@mantine/core";
import StatsField from "./reusable/StatsField";
import { IconActivity } from "@tabler/icons";
import ContractStateToggle from "./ContractStateToggle";

const MintingEnabledToggle = ({ contractId, contractInfo, onUpdate }) => {
  return (
    <Group position="apart" grow>
      <StatsField
        label="Minting Enabled"
        value={
          <Badge
            size="xs"
            color={contractInfo.mintingEnabled ? "green" : "red"}
          >
            {contractInfo.mintingEnabled.toString()}
          </Badge>
        }
        icon={IconActivity}
      />
      <ContractStateToggle
        contractId={contractId}
        abi={[
          {
            inputs: [],
            name: "toggleMinting",
            outputs: [],
            stateMutability: "nonpayable",
            type: "function"
          }
        ]}
        functionName="toggleMinting"
        enabled={contractInfo.mintingEnabled}
        onCompleted={() => onUpdate(contractId)}
        label="Toggle minting"
      />
    </Group>
  );
};

export default MintingEnabledToggle;
